import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';

@Component({
  selector: 'app-savings',
  imports: [MatCardModule],
  templateUrl: './savings.html',
  styleUrl: './savings.scss'
})
export class Savings {

  constructor( public themeService: CustomizerSettingsService ) {}

}